export default {
  Actions: {
    CREATE_WORKSPACE_AI_SETTING_SUCCESS: 'workspace_ai_settings/CREATE_WORKSPACE_AI_SETTING_SUCCESS',
    UPDATE_WORKSPACE_AI_SETTING_SUCCESS: 'workspace_ai_settings/UPDATE_WORKSPACE_AI_SETTING_SUCCESS',
    DELETE_WORKSPACE_AI_SETTING_SUCCESS: 'workspace_ai_settings/DELETE_WORKSPACE_AI_SETTING_SUCCESS',
  },
  State: {
    WORKSPACE_AI_SETTINGS_BY_WORKSPACE_SLUG: 'WORKSPACE_AI_SETTINGS_BY_WORKSPACE_SLUG',
  },
};
